<div class="container page">
    <h1>{{'about_title' | translate}}</h1>
    <div class="panel text" [innerHTML]="content"></div>
</div>